// extracted by mini-css-extract-plugin
module.exports = {"link":"_25d45facb5--link--e7z7V","icon":"_25d45facb5--icon--IBQt2","icon-pik":"_25d45facb5--icon-pik--b1At6","title":"_25d45facb5--title--nV4cM"};